/*
  ULTREIA v16 — estantes y librería.
  Cuatro cosas chicas, sin dependencias:
    1 · flechas de los estantes      ([data-u-estante])
    2 · "Seguí leyendo"              ([data-u-relacionados])
    3 · cabecera de la librería      ([data-u-libreria-cuenta], [data-u-estantes])
    4 · el estante aparece entero    ([data-u-estante-riel])

  Lo cargan con defer las secciones que lo necesitan (puede venir más de
  una vez en la misma página: la guarda de abajo evita engancharlo dos
  veces). Sin JavaScript todo sigue andando: el riel se desliza con el
  dedo, la rueda o el teclado; "Seguí leyendo" simplemente no aparece.
*/
(function () {
  'use strict';
  if (window.UltreiaEstante) return;
  window.UltreiaEstante = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1 · FLECHAS ────────────────────────────────────────────────
     <section data-u-estante>
       … [data-u-estante-flechas] (el marco del riel) >
           [data-u-estante-prev] [data-u-estante-riel] [data-u-estante-next]
           [data-u-estante-progreso]
     Una flecha redonda a cada lado, a media altura de las tapas, como en
     v15: solo aparece si hay para dónde ir (en el principio no se ve la
     de la izquierda; al final, la de la derecha). Avanzan de a "casi una
     pantalla" de tapas; el scroll-snap deja la primera bien apoyada. */
  function estante(est) {
    if (est.dataset.uListo) return est._uPintar;
    var riel = est.querySelector('[data-u-estante-riel]');
    var prev = est.querySelector('[data-u-estante-prev]');
    var next = est.querySelector('[data-u-estante-next]');
    var progreso = est.querySelector('[data-u-estante-progreso]');
    var barra = progreso && progreso.firstElementChild;
    if (!riel || !prev || !next) return null;
    est.dataset.uListo = '1';

    /* Con principio y fin, como v15 (v16.5). El bucle infinito copiaba el
       estante dos veces y saltaba al llegar a la copia: las tapas copiadas
       llegaban tarde y por un instante asomaba "Ver todo el estante". Ahora
       ese final es el destino: la flecha de cada lado se va en su extremo. */
    function paso(dir) {
      var boton = dir > 0 ? next : prev;
      if (boton.getAttribute('aria-disabled') === 'true') return;
      riel.scrollBy({ left: dir * Math.max(riel.clientWidth * 0.8, 200), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { paso(-1); });
    next.addEventListener('click', function () { paso(1); });

    var pendiente = false;
    function pintar() {
      pendiente = false;
      var total = riel.scrollWidth, visible = riel.clientWidth, max = total - visible;
      var hay = max > 4;
      prev.hidden = next.hidden = !hay;
      if (progreso) progreso.hidden = !hay;
      if (!hay) return;
      prev.setAttribute('aria-disabled', riel.scrollLeft <= 4 ? 'true' : 'false');
      next.setAttribute('aria-disabled', riel.scrollLeft >= max - 4 ? 'true' : 'false');
      if (barra) {
        barra.style.width = (visible / total * 100).toFixed(2) + '%';
        barra.style.left = (riel.scrollLeft / total * 100).toFixed(2) + '%';
      }
    }
    function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }
    riel.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    pintar();
    est._uPintar = pedir;
    return pedir;
  }

  /* 2 · SEGUÍ LEYENDO ────────────────────────────────────────────────────
     El criterio es el de v15: el estante (la etiqueta "Género: X"). Shopify
     sirve la colección filtrada por esa etiqueta; se le pide UNA página
     dibujada por la misma sección (Section Rendering API,
     ?section_id=ultreia-relacionados), que en ese contexto devuelve las
     tarjetas ya armadas dentro de un <template data-u-feed>. Antes se
     bajaban TODAS las páginas de la colección como HTML completo (662 KB
     en Hábitos atómicos); ahora es un pedido y solo las tarjetas.

     Se saca el libro que se está mirando y se rota el punto de partida con
     un número que sale del handle: cada ficha arranca en un lugar distinto
     del estante, y siempre el mismo para esa ficha. Se pide recién cuando
     el bloque se acerca a la pantalla. */
  function semilla(txt) {
    var h = 0;
    for (var i = 0; i < txt.length; i++) h = (h * 31 + txt.charCodeAt(i)) % 100000;
    return h;
  }
  function relacionados(est) {
    if (est.dataset.uPedido) return;
    est.dataset.uPedido = '1';
    var url = est.getAttribute('data-u-relacionados');
    var actual = est.getAttribute('data-u-actual') || '';
    var tope = parseInt(est.getAttribute('data-u-tope'), 10) || 10;
    var riel = est.querySelector('[data-u-estante-riel]');
    if (!url || !riel) return;

    function quitar() { est.remove(); }
    function traer() {
      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=ultreia-relacionados')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tpl = doc.querySelector('template[data-u-feed]');
          if (!tpl) return quitar();
          var items = [].slice.call(tpl.content.querySelectorAll('li[data-handle]')).filter(function (li) {
            return li.getAttribute('data-handle') !== actual;
          });
          if (items.length < 2) return quitar();
          var desde = semilla(actual) % items.length;
          items = items.slice(desde).concat(items.slice(0, desde)).slice(0, tope);

          [].slice.call(riel.querySelectorAll('.u-estante__hueco')).forEach(function (h) { h.remove(); });
          var fin = riel.querySelector('.u-estante__fin');
          items.forEach(function (li, i) {
            var nodo = document.importNode(li, true);
            var art = nodo.querySelector('[data-u-aparece]');
            if (art) art.style.setProperty('--u-i', String(i % 6));
            riel.insertBefore(nodo, fin);
          });
          riel.removeAttribute('aria-busy');
          var pintar = estante(est);
          if (pintar) pintar();
          if (window.Ultreia && window.Ultreia.escanear) window.Ultreia.escanear(est);
          revelar(est);
        })
        .catch(quitar);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { io.disconnect(); traer(); }
      }, { rootMargin: '400px 0px' });
      io.observe(est);
    } else {
      traer();
    }
  }

  /* 3 · CABECERA DE LA LIBRERÍA ──────────────────────────────────────────
     a) La cuenta ("450 libros") de la cabecera copia a #ProductCount, que
        es la que facets.js de Dawn reescribe al filtrar. Así hay una sola
        cuenta a la vista y no se toca facets.js.
     b) En el celular los estantes son una fila que se desliza: si hay uno
        elegido, se lo trae a la vista. */
  function libreria(raiz) {
    var destino = raiz.querySelector('[data-u-libreria-cuenta]');
    var fuente = document.getElementById('ProductCount');
    if (destino && fuente && !destino.dataset.uListo) {
      destino.dataset.uListo = '1';
      new MutationObserver(function () {
        if (fuente.classList.contains('loading')) return;
        var t = fuente.textContent.replace(/\s+/g, ' ').trim();
        if (t) destino.textContent = t;
      }).observe(fuente, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    [].forEach.call(raiz.querySelectorAll('[data-u-estantes]'), function (nav) {
      var lista = nav.querySelector('.u-estantes__lista');
      var activo = nav.querySelector('[aria-current="page"]');
      if (!lista || !activo || lista.scrollWidth <= lista.clientWidth + 2) return;
      var pad = parseFloat(getComputedStyle(lista).paddingLeft) || 0;
      var x = activo.getBoundingClientRect().left - lista.getBoundingClientRect().left + lista.scrollLeft - pad;
      lista.scrollLeft = Math.max(0, x);
    });
  }

  /* 4 · APARICIÓN DEL ESTANTE ───────────────────────────────────────────
     Cada tarjeta trae data-u-aparece, y el sistema la muestra cuando entra
     en la pantalla. En un riel horizontal eso significa que las tapas de
     la derecha (recortadas por el riel) recién aparecen al deslizarlo: el
     libro llega tarde al dedo. Acá el estante aparece entero cuando el
     riel se asoma, con el escalonado de siempre en las primeras tapas. */
  function revelar(est) {
    var riel = est.querySelector('[data-u-estante-riel]');
    if (!riel) return;
    function mostrar() {
      [].forEach.call(riel.querySelectorAll('[data-u-aparece]:not(.is-visto)'), function (n) { n.classList.add('is-visto'); });
    }
    if (!('IntersectionObserver' in window)) return mostrar();
    if (riel._uVisor) riel._uVisor.disconnect();
    riel._uVisor = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { riel._uVisor.disconnect(); mostrar(); }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    riel._uVisor.observe(riel);
  }

  function arrancar(raiz) {
    [].forEach.call(raiz.querySelectorAll('[data-u-estante]'), function (est) {
      if (est.hasAttribute('data-u-relacionados')) relacionados(est);
      else { estante(est); revelar(est); }
    });
    libreria(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  else arrancar(document);
  document.addEventListener('shopify:section:load', function (e) { arrancar(e.target); });
})();
